__turbopack_context__.v({
  "body": "policy-module-scss-module__bejEcq__body",
  "body-20": "policy-module-scss-module__bejEcq__body-20",
  "body-20--lg": "policy-module-scss-module__bejEcq__body-20--lg",
  "body-20--md": "policy-module-scss-module__bejEcq__body-20--md",
  "body-20--modal-button-layout-shift": "policy-module-scss-module__bejEcq__body-20--modal-button-layout-shift",
  "body-20--sm": "policy-module-scss-module__bejEcq__body-20--sm",
  "body-20--tablet": "policy-module-scss-module__bejEcq__body-20--tablet",
  "body-20--xl": "policy-module-scss-module__bejEcq__body-20--xl",
  "body-20--xs": "policy-module-scss-module__bejEcq__body-20--xs",
  "body-20--xxs": "policy-module-scss-module__bejEcq__body-20--xxs",
  "body-2xl": "policy-module-scss-module__bejEcq__body-2xl",
  "body-2xl--lg": "policy-module-scss-module__bejEcq__body-2xl--lg",
  "body-2xl--md": "policy-module-scss-module__bejEcq__body-2xl--md",
  "body-2xl--modal-button-layout-shift": "policy-module-scss-module__bejEcq__body-2xl--modal-button-layout-shift",
  "body-2xl--sm": "policy-module-scss-module__bejEcq__body-2xl--sm",
  "body-2xl--tablet": "policy-module-scss-module__bejEcq__body-2xl--tablet",
  "body-2xl--xl": "policy-module-scss-module__bejEcq__body-2xl--xl",
  "body-2xl--xs": "policy-module-scss-module__bejEcq__body-2xl--xs",
  "body-2xl--xxs": "policy-module-scss-module__bejEcq__body-2xl--xxs",
  "body-2xs": "policy-module-scss-module__bejEcq__body-2xs",
  "body-2xs--lg": "policy-module-scss-module__bejEcq__body-2xs--lg",
  "body-2xs--md": "policy-module-scss-module__bejEcq__body-2xs--md",
  "body-2xs--modal-button-layout-shift": "policy-module-scss-module__bejEcq__body-2xs--modal-button-layout-shift",
  "body-2xs--sm": "policy-module-scss-module__bejEcq__body-2xs--sm",
  "body-2xs--tablet": "policy-module-scss-module__bejEcq__body-2xs--tablet",
  "body-2xs--xl": "policy-module-scss-module__bejEcq__body-2xs--xl",
  "body-2xs--xs": "policy-module-scss-module__bejEcq__body-2xs--xs",
  "body-2xs--xxs": "policy-module-scss-module__bejEcq__body-2xs--xxs",
  "body-3xl": "policy-module-scss-module__bejEcq__body-3xl",
  "body-3xl--lg": "policy-module-scss-module__bejEcq__body-3xl--lg",
  "body-3xl--md": "policy-module-scss-module__bejEcq__body-3xl--md",
  "body-3xl--modal-button-layout-shift": "policy-module-scss-module__bejEcq__body-3xl--modal-button-layout-shift",
  "body-3xl--sm": "policy-module-scss-module__bejEcq__body-3xl--sm",
  "body-3xl--tablet": "policy-module-scss-module__bejEcq__body-3xl--tablet",
  "body-3xl--xl": "policy-module-scss-module__bejEcq__body-3xl--xl",
  "body-3xl--xs": "policy-module-scss-module__bejEcq__body-3xl--xs",
  "body-3xl--xxs": "policy-module-scss-module__bejEcq__body-3xl--xxs",
  "body-3xs": "policy-module-scss-module__bejEcq__body-3xs",
  "body-3xs--lg": "policy-module-scss-module__bejEcq__body-3xs--lg",
  "body-3xs--md": "policy-module-scss-module__bejEcq__body-3xs--md",
  "body-3xs--modal-button-layout-shift": "policy-module-scss-module__bejEcq__body-3xs--modal-button-layout-shift",
  "body-3xs--sm": "policy-module-scss-module__bejEcq__body-3xs--sm",
  "body-3xs--tablet": "policy-module-scss-module__bejEcq__body-3xs--tablet",
  "body-3xs--xl": "policy-module-scss-module__bejEcq__body-3xs--xl",
  "body-3xs--xs": "policy-module-scss-module__bejEcq__body-3xs--xs",
  "body-3xs--xxs": "policy-module-scss-module__bejEcq__body-3xs--xxs",
  "body-lg": "policy-module-scss-module__bejEcq__body-lg",
  "body-lg--lg": "policy-module-scss-module__bejEcq__body-lg--lg",
  "body-lg--md": "policy-module-scss-module__bejEcq__body-lg--md",
  "body-lg--modal-button-layout-shift": "policy-module-scss-module__bejEcq__body-lg--modal-button-layout-shift",
  "body-lg--sm": "policy-module-scss-module__bejEcq__body-lg--sm",
  "body-lg--tablet": "policy-module-scss-module__bejEcq__body-lg--tablet",
  "body-lg--xl": "policy-module-scss-module__bejEcq__body-lg--xl",
  "body-lg--xs": "policy-module-scss-module__bejEcq__body-lg--xs",
  "body-lg--xxs": "policy-module-scss-module__bejEcq__body-lg--xxs",
  "body-md": "policy-module-scss-module__bejEcq__body-md",
  "body-md--lg": "policy-module-scss-module__bejEcq__body-md--lg",
  "body-md--md": "policy-module-scss-module__bejEcq__body-md--md",
  "body-md--modal-button-layout-shift": "policy-module-scss-module__bejEcq__body-md--modal-button-layout-shift",
  "body-md--sm": "policy-module-scss-module__bejEcq__body-md--sm",
  "body-md--tablet": "policy-module-scss-module__bejEcq__body-md--tablet",
  "body-md--xl": "policy-module-scss-module__bejEcq__body-md--xl",
  "body-md--xs": "policy-module-scss-module__bejEcq__body-md--xs",
  "body-md--xxs": "policy-module-scss-module__bejEcq__body-md--xxs",
  "body-xl": "policy-module-scss-module__bejEcq__body-xl",
  "body-xl--lg": "policy-module-scss-module__bejEcq__body-xl--lg",
  "body-xl--md": "policy-module-scss-module__bejEcq__body-xl--md",
  "body-xl--modal-button-layout-shift": "policy-module-scss-module__bejEcq__body-xl--modal-button-layout-shift",
  "body-xl--sm": "policy-module-scss-module__bejEcq__body-xl--sm",
  "body-xl--tablet": "policy-module-scss-module__bejEcq__body-xl--tablet",
  "body-xl--xl": "policy-module-scss-module__bejEcq__body-xl--xl",
  "body-xl--xs": "policy-module-scss-module__bejEcq__body-xl--xs",
  "body-xl--xxs": "policy-module-scss-module__bejEcq__body-xl--xxs",
  "body-xs": "policy-module-scss-module__bejEcq__body-xs",
  "body-xs--lg": "policy-module-scss-module__bejEcq__body-xs--lg",
  "body-xs--md": "policy-module-scss-module__bejEcq__body-xs--md",
  "body-xs--modal-button-layout-shift": "policy-module-scss-module__bejEcq__body-xs--modal-button-layout-shift",
  "body-xs--sm": "policy-module-scss-module__bejEcq__body-xs--sm",
  "body-xs--tablet": "policy-module-scss-module__bejEcq__body-xs--tablet",
  "body-xs--xl": "policy-module-scss-module__bejEcq__body-xs--xl",
  "body-xs--xs": "policy-module-scss-module__bejEcq__body-xs--xs",
  "body-xs--xxs": "policy-module-scss-module__bejEcq__body-xs--xxs",
  "breadcrumbs": "policy-module-scss-module__bejEcq__breadcrumbs",
  "heading-120": "policy-module-scss-module__bejEcq__heading-120",
  "heading-120--lg": "policy-module-scss-module__bejEcq__heading-120--lg",
  "heading-120--md": "policy-module-scss-module__bejEcq__heading-120--md",
  "heading-120--modal-button-layout-shift": "policy-module-scss-module__bejEcq__heading-120--modal-button-layout-shift",
  "heading-120--sm": "policy-module-scss-module__bejEcq__heading-120--sm",
  "heading-120--tablet": "policy-module-scss-module__bejEcq__heading-120--tablet",
  "heading-120--xl": "policy-module-scss-module__bejEcq__heading-120--xl",
  "heading-120--xs": "policy-module-scss-module__bejEcq__heading-120--xs",
  "heading-120--xxs": "policy-module-scss-module__bejEcq__heading-120--xxs",
  "heading-128": "policy-module-scss-module__bejEcq__heading-128",
  "heading-128--lg": "policy-module-scss-module__bejEcq__heading-128--lg",
  "heading-128--md": "policy-module-scss-module__bejEcq__heading-128--md",
  "heading-128--modal-button-layout-shift": "policy-module-scss-module__bejEcq__heading-128--modal-button-layout-shift",
  "heading-128--sm": "policy-module-scss-module__bejEcq__heading-128--sm",
  "heading-128--tablet": "policy-module-scss-module__bejEcq__heading-128--tablet",
  "heading-128--xl": "policy-module-scss-module__bejEcq__heading-128--xl",
  "heading-128--xs": "policy-module-scss-module__bejEcq__heading-128--xs",
  "heading-128--xxs": "policy-module-scss-module__bejEcq__heading-128--xxs",
  "heading-150": "policy-module-scss-module__bejEcq__heading-150",
  "heading-150--lg": "policy-module-scss-module__bejEcq__heading-150--lg",
  "heading-150--md": "policy-module-scss-module__bejEcq__heading-150--md",
  "heading-150--modal-button-layout-shift": "policy-module-scss-module__bejEcq__heading-150--modal-button-layout-shift",
  "heading-150--sm": "policy-module-scss-module__bejEcq__heading-150--sm",
  "heading-150--tablet": "policy-module-scss-module__bejEcq__heading-150--tablet",
  "heading-150--xl": "policy-module-scss-module__bejEcq__heading-150--xl",
  "heading-150--xs": "policy-module-scss-module__bejEcq__heading-150--xs",
  "heading-150--xxs": "policy-module-scss-module__bejEcq__heading-150--xxs",
  "heading-2xl": "policy-module-scss-module__bejEcq__heading-2xl",
  "heading-2xl--lg": "policy-module-scss-module__bejEcq__heading-2xl--lg",
  "heading-2xl--md": "policy-module-scss-module__bejEcq__heading-2xl--md",
  "heading-2xl--modal-button-layout-shift": "policy-module-scss-module__bejEcq__heading-2xl--modal-button-layout-shift",
  "heading-2xl--sm": "policy-module-scss-module__bejEcq__heading-2xl--sm",
  "heading-2xl--tablet": "policy-module-scss-module__bejEcq__heading-2xl--tablet",
  "heading-2xl--xl": "policy-module-scss-module__bejEcq__heading-2xl--xl",
  "heading-2xl--xs": "policy-module-scss-module__bejEcq__heading-2xl--xs",
  "heading-2xl--xxs": "policy-module-scss-module__bejEcq__heading-2xl--xxs",
  "heading-3xl": "policy-module-scss-module__bejEcq__heading-3xl",
  "heading-3xl--lg": "policy-module-scss-module__bejEcq__heading-3xl--lg",
  "heading-3xl--md": "policy-module-scss-module__bejEcq__heading-3xl--md",
  "heading-3xl--modal-button-layout-shift": "policy-module-scss-module__bejEcq__heading-3xl--modal-button-layout-shift",
  "heading-3xl--sm": "policy-module-scss-module__bejEcq__heading-3xl--sm",
  "heading-3xl--tablet": "policy-module-scss-module__bejEcq__heading-3xl--tablet",
  "heading-3xl--xl": "policy-module-scss-module__bejEcq__heading-3xl--xl",
  "heading-3xl--xs": "policy-module-scss-module__bejEcq__heading-3xl--xs",
  "heading-3xl--xxs": "policy-module-scss-module__bejEcq__heading-3xl--xxs",
  "heading-4xl": "policy-module-scss-module__bejEcq__heading-4xl",
  "heading-4xl--lg": "policy-module-scss-module__bejEcq__heading-4xl--lg",
  "heading-4xl--md": "policy-module-scss-module__bejEcq__heading-4xl--md",
  "heading-4xl--modal-button-layout-shift": "policy-module-scss-module__bejEcq__heading-4xl--modal-button-layout-shift",
  "heading-4xl--sm": "policy-module-scss-module__bejEcq__heading-4xl--sm",
  "heading-4xl--tablet": "policy-module-scss-module__bejEcq__heading-4xl--tablet",
  "heading-4xl--xl": "policy-module-scss-module__bejEcq__heading-4xl--xl",
  "heading-4xl--xs": "policy-module-scss-module__bejEcq__heading-4xl--xs",
  "heading-4xl--xxs": "policy-module-scss-module__bejEcq__heading-4xl--xxs",
  "heading-5xl": "policy-module-scss-module__bejEcq__heading-5xl",
  "heading-5xl--lg": "policy-module-scss-module__bejEcq__heading-5xl--lg",
  "heading-5xl--md": "policy-module-scss-module__bejEcq__heading-5xl--md",
  "heading-5xl--modal-button-layout-shift": "policy-module-scss-module__bejEcq__heading-5xl--modal-button-layout-shift",
  "heading-5xl--sm": "policy-module-scss-module__bejEcq__heading-5xl--sm",
  "heading-5xl--tablet": "policy-module-scss-module__bejEcq__heading-5xl--tablet",
  "heading-5xl--xl": "policy-module-scss-module__bejEcq__heading-5xl--xl",
  "heading-5xl--xs": "policy-module-scss-module__bejEcq__heading-5xl--xs",
  "heading-5xl--xxs": "policy-module-scss-module__bejEcq__heading-5xl--xxs",
  "heading-60": "policy-module-scss-module__bejEcq__heading-60",
  "heading-60--lg": "policy-module-scss-module__bejEcq__heading-60--lg",
  "heading-60--md": "policy-module-scss-module__bejEcq__heading-60--md",
  "heading-60--modal-button-layout-shift": "policy-module-scss-module__bejEcq__heading-60--modal-button-layout-shift",
  "heading-60--sm": "policy-module-scss-module__bejEcq__heading-60--sm",
  "heading-60--tablet": "policy-module-scss-module__bejEcq__heading-60--tablet",
  "heading-60--xl": "policy-module-scss-module__bejEcq__heading-60--xl",
  "heading-60--xs": "policy-module-scss-module__bejEcq__heading-60--xs",
  "heading-60--xxs": "policy-module-scss-module__bejEcq__heading-60--xxs",
  "heading-70": "policy-module-scss-module__bejEcq__heading-70",
  "heading-70--lg": "policy-module-scss-module__bejEcq__heading-70--lg",
  "heading-70--md": "policy-module-scss-module__bejEcq__heading-70--md",
  "heading-70--modal-button-layout-shift": "policy-module-scss-module__bejEcq__heading-70--modal-button-layout-shift",
  "heading-70--sm": "policy-module-scss-module__bejEcq__heading-70--sm",
  "heading-70--tablet": "policy-module-scss-module__bejEcq__heading-70--tablet",
  "heading-70--xl": "policy-module-scss-module__bejEcq__heading-70--xl",
  "heading-70--xs": "policy-module-scss-module__bejEcq__heading-70--xs",
  "heading-70--xxs": "policy-module-scss-module__bejEcq__heading-70--xxs",
  "heading-90": "policy-module-scss-module__bejEcq__heading-90",
  "heading-90--lg": "policy-module-scss-module__bejEcq__heading-90--lg",
  "heading-90--md": "policy-module-scss-module__bejEcq__heading-90--md",
  "heading-90--modal-button-layout-shift": "policy-module-scss-module__bejEcq__heading-90--modal-button-layout-shift",
  "heading-90--sm": "policy-module-scss-module__bejEcq__heading-90--sm",
  "heading-90--tablet": "policy-module-scss-module__bejEcq__heading-90--tablet",
  "heading-90--xl": "policy-module-scss-module__bejEcq__heading-90--xl",
  "heading-90--xs": "policy-module-scss-module__bejEcq__heading-90--xs",
  "heading-90--xxs": "policy-module-scss-module__bejEcq__heading-90--xxs",
  "heading-lg": "policy-module-scss-module__bejEcq__heading-lg",
  "heading-lg--lg": "policy-module-scss-module__bejEcq__heading-lg--lg",
  "heading-lg--md": "policy-module-scss-module__bejEcq__heading-lg--md",
  "heading-lg--modal-button-layout-shift": "policy-module-scss-module__bejEcq__heading-lg--modal-button-layout-shift",
  "heading-lg--sm": "policy-module-scss-module__bejEcq__heading-lg--sm",
  "heading-lg--tablet": "policy-module-scss-module__bejEcq__heading-lg--tablet",
  "heading-lg--xl": "policy-module-scss-module__bejEcq__heading-lg--xl",
  "heading-lg--xs": "policy-module-scss-module__bejEcq__heading-lg--xs",
  "heading-lg--xxs": "policy-module-scss-module__bejEcq__heading-lg--xxs",
  "heading-md": "policy-module-scss-module__bejEcq__heading-md",
  "heading-md--lg": "policy-module-scss-module__bejEcq__heading-md--lg",
  "heading-md--md": "policy-module-scss-module__bejEcq__heading-md--md",
  "heading-md--modal-button-layout-shift": "policy-module-scss-module__bejEcq__heading-md--modal-button-layout-shift",
  "heading-md--sm": "policy-module-scss-module__bejEcq__heading-md--sm",
  "heading-md--tablet": "policy-module-scss-module__bejEcq__heading-md--tablet",
  "heading-md--xl": "policy-module-scss-module__bejEcq__heading-md--xl",
  "heading-md--xs": "policy-module-scss-module__bejEcq__heading-md--xs",
  "heading-md--xxs": "policy-module-scss-module__bejEcq__heading-md--xxs",
  "heading-sm": "policy-module-scss-module__bejEcq__heading-sm",
  "heading-sm--lg": "policy-module-scss-module__bejEcq__heading-sm--lg",
  "heading-sm--md": "policy-module-scss-module__bejEcq__heading-sm--md",
  "heading-sm--modal-button-layout-shift": "policy-module-scss-module__bejEcq__heading-sm--modal-button-layout-shift",
  "heading-sm--sm": "policy-module-scss-module__bejEcq__heading-sm--sm",
  "heading-sm--tablet": "policy-module-scss-module__bejEcq__heading-sm--tablet",
  "heading-sm--xl": "policy-module-scss-module__bejEcq__heading-sm--xl",
  "heading-sm--xs": "policy-module-scss-module__bejEcq__heading-sm--xs",
  "heading-sm--xxs": "policy-module-scss-module__bejEcq__heading-sm--xxs",
  "heading-xl": "policy-module-scss-module__bejEcq__heading-xl",
  "heading-xl--lg": "policy-module-scss-module__bejEcq__heading-xl--lg",
  "heading-xl--md": "policy-module-scss-module__bejEcq__heading-xl--md",
  "heading-xl--modal-button-layout-shift": "policy-module-scss-module__bejEcq__heading-xl--modal-button-layout-shift",
  "heading-xl--sm": "policy-module-scss-module__bejEcq__heading-xl--sm",
  "heading-xl--tablet": "policy-module-scss-module__bejEcq__heading-xl--tablet",
  "heading-xl--xl": "policy-module-scss-module__bejEcq__heading-xl--xl",
  "heading-xl--xs": "policy-module-scss-module__bejEcq__heading-xl--xs",
  "heading-xl--xxs": "policy-module-scss-module__bejEcq__heading-xl--xxs",
  "heading-xs": "policy-module-scss-module__bejEcq__heading-xs",
  "heading-xs--lg": "policy-module-scss-module__bejEcq__heading-xs--lg",
  "heading-xs--md": "policy-module-scss-module__bejEcq__heading-xs--md",
  "heading-xs--modal-button-layout-shift": "policy-module-scss-module__bejEcq__heading-xs--modal-button-layout-shift",
  "heading-xs--sm": "policy-module-scss-module__bejEcq__heading-xs--sm",
  "heading-xs--tablet": "policy-module-scss-module__bejEcq__heading-xs--tablet",
  "heading-xs--xl": "policy-module-scss-module__bejEcq__heading-xs--xl",
  "heading-xs--xs": "policy-module-scss-module__bejEcq__heading-xs--xs",
  "heading-xs--xxs": "policy-module-scss-module__bejEcq__heading-xs--xxs",
  "heading-xxs": "policy-module-scss-module__bejEcq__heading-xxs",
  "heading-xxs--lg": "policy-module-scss-module__bejEcq__heading-xxs--lg",
  "heading-xxs--md": "policy-module-scss-module__bejEcq__heading-xxs--md",
  "heading-xxs--modal-button-layout-shift": "policy-module-scss-module__bejEcq__heading-xxs--modal-button-layout-shift",
  "heading-xxs--sm": "policy-module-scss-module__bejEcq__heading-xxs--sm",
  "heading-xxs--tablet": "policy-module-scss-module__bejEcq__heading-xxs--tablet",
  "heading-xxs--xl": "policy-module-scss-module__bejEcq__heading-xxs--xl",
  "heading-xxs--xs": "policy-module-scss-module__bejEcq__heading-xxs--xs",
  "heading-xxs--xxs": "policy-module-scss-module__bejEcq__heading-xxs--xxs",
  "large-prompt": "policy-module-scss-module__bejEcq__large-prompt",
  "large-prompt--lg": "policy-module-scss-module__bejEcq__large-prompt--lg",
  "large-prompt--md": "policy-module-scss-module__bejEcq__large-prompt--md",
  "large-prompt--modal-button-layout-shift": "policy-module-scss-module__bejEcq__large-prompt--modal-button-layout-shift",
  "large-prompt--sm": "policy-module-scss-module__bejEcq__large-prompt--sm",
  "large-prompt--tablet": "policy-module-scss-module__bejEcq__large-prompt--tablet",
  "large-prompt--xl": "policy-module-scss-module__bejEcq__large-prompt--xl",
  "large-prompt--xs": "policy-module-scss-module__bejEcq__large-prompt--xs",
  "large-prompt--xxs": "policy-module-scss-module__bejEcq__large-prompt--xxs",
  "time": "policy-module-scss-module__bejEcq__time",
});
